import i18n from 'i18next';
import { COUNT, AMOUNT, statusDesc } from './constants';

const filteredResponse = response =>
  response.filter(item => statusDesc.map(status => status.id).includes(item.paymentStatusId));

export const getTransactionSummaryData = response => {
  return filteredResponse(response).reduce(
    (acc, item) => {
      const { paymentStatusId, countOfTransactions, sumOfTransactions } = item;

      // Group by specific paymentStatusId values
      if (statusDesc.map(status => status.id).includes(paymentStatusId)) {
        if (!acc[paymentStatusId]) {
          acc[paymentStatusId] = {
            count: 0,
            amount: 0
          };
        }
        acc[paymentStatusId].count += countOfTransactions;
        acc[paymentStatusId].amount += sumOfTransactions;
      }

      // Group for all paymentStatusId values
      acc.all.count += countOfTransactions;
      acc.all.amount += sumOfTransactions;

      return acc;
    },
    {
      1: { count: 0, amount: 0 },
      10: { count: 0, amount: 0 },
      2: { count: 0, amount: 0 },
      all: { count: 0, amount: 0 }
    }
  );
};

export const getChartsData = response => {
  const platform = filteredResponse(response).reduce((acc, item) => {
    const { platformId, countOfTransactions, sumOfTransactions } = item;

    if (!acc[platformId]) {
      acc[platformId] = {
        count: 0,
        amount: 0
      };
    }

    acc[platformId].count += countOfTransactions;
    acc[platformId].amount += sumOfTransactions;

    return acc;
  }, {});

  const method = filteredResponse(response).reduce((acc, item) => {
    const { methodCodeId, countOfTransactions, sumOfTransactions } = item;

    if (!acc[methodCodeId]) {
      acc[methodCodeId] = {
        count: 0,
        amount: 0
      };
    }

    acc[methodCodeId].count += countOfTransactions;
    acc[methodCodeId].amount += sumOfTransactions;

    return acc;
  }, {});

  const status = filteredResponse(response).reduce((acc, item) => {
    const { paymentStatusId, countOfTransactions, sumOfTransactions } = item;

    if (!acc[paymentStatusId]) {
      acc[paymentStatusId] = {
        count: 0,
        amount: 0
      };
    }

    acc[paymentStatusId].count += countOfTransactions;
    acc[paymentStatusId].amount += sumOfTransactions;

    return acc;
  }, {});

  return {
    graphByPlatform: platform,
    graphByStatus: status,
    graphByPaymentMethod: method
  };
};

export const mapSummaryData = (data, dataType) => {
  return [
    {
      title: i18n.t('dashboard.transactionSummary.total'),
      value: dataType === COUNT ? data.all.count : data.all.amount
    },
    {
      title: i18n.t('dashboard.transactionSummary.deposits'),
      value: dataType === COUNT ? data[1].count : data[1].amount
    },
    {
      title: i18n.t('dashboard.transactionSummary.refunds'),
      value: dataType === COUNT ? data[10].count : data[10].amount
    },
    {
      title: i18n.t('dashboard.transactionSummary.returns'),
      value: dataType === COUNT ? data[2].count : data[2].amount
    }
  ];
};

export const getChartConfig = (data, filterSource, dataType) => {
  const { methodSource, platformSource } = filterSource;

  const updPlatform = updateDataChart(data.graphByPlatform, platformSource);
  const updMethod = updateDataChart(data.graphByPaymentMethod, methodSource);
  const updStatus = updateDataChart(data.graphByStatus, statusDesc);

  return {
    graphByPlatform: mapByDescription(updPlatform, dataType),
    graphByPaymentMethod: mapByDescription(updMethod, dataType),
    graphByStatus: mapByDescription(updStatus, dataType)
  };
};

const updateDataChart = (data, source) => {
  return Object.keys(data).map(key => {
    const descriptionObj = source.find(desc => desc.id === parseInt(key));
    return {
      statusId: key,
      count: data[key].count,
      amount: data[key].amount,
      description: descriptionObj?.description || descriptionObj?.name
    };
  });
};

const mapByDescription = (list, flag) => {
  return list.reduce((acc, item) => {
    const { description } = item;
    acc[description] = flag === COUNT ? item.count : item.amount;
    return acc;
  }, {});
};
